<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark :color="pages.header.back" fixed>
          <v-btn icon dark @click="fecharModal()">
            <v-icon :class="pages.header.class">close</v-icon>
          </v-btn>
          <v-toolbar-title :class="pages.header.class">Pedido</v-toolbar-title>
          <!--
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :class="pages.header.class" dark flat @click="$emit('fechar-modal')">Finalizar</v-btn>
          </v-toolbar-items>
          -->
        </v-toolbar>
        <div style="padding-top: 50px;"></div>
        <template>
            <v-subheader>
              <div class="ml-auto subheading mt-3 font-weight-bold text-xs-center">
                Total do pedido: R$ {{totalPedido.total.toFixed(2).replace(".",",")}}
              </div>
            </v-subheader>
            <v-divider></v-divider>
            <template v-for="(produto,pIndex) in cart">
              <v-card class="mb-2"> 
                  <v-card-text>
                    <div class="subheading">{{produto.nome}}</div>
                    <div class="grey--text" v-if="produto.variacao && produto.variacao!='false'">
                      <template v-for="(variacao,VarIndex) in produto.variacao.value" v-if="produto.variacao.value">
                        <span v-if="VarIndex"><br></span>{{variacao.nome}}<span v-if="variacao.valor && parseFloat(variacao.valor)>0">
                          <span v-if="variacao.val=='alt'" v-html="': R$ '+parseFloat(variacao.valor).toFixed(2).replace('.',',')"></span>
                          <span v-else-if="variacao.val=='add'" v-html="' (+ R$ '+parseFloat(variacao.valor).toFixed(2).replace('.',',')+')'"></span>
                        </span>
                      </template>
                    </div>
                    <div class="grey--text caption" v-if="produto.opcionais">
                      <template v-for="(opcional,OplIndex) in produto.opcionais">
                        <span v-if="OplIndex">, </span>{{opcional.nome}}<span v-if="opcional.valor">(R$: {{opcional.valor}})</span>
                      </template>
                    </div>
                    <v-layout>
                      <v-flex xs8 class="">
                        <div class="my-2"> R$ {{produto.subtotal.toFixed(2).replace('.',',')}}</div>
                      </v-flex>
                      <v-flex xs4 class="text-xs-right">
                        <v-item-group>
                          <v-btn color="error" icon small @click="$emit('clique-botao-remove',pIndex)" class="mx-0">
                            <v-icon>remove</v-icon>
                          </v-btn>
                          <span class="subheading mx-2 font-weight-bold">{{produto.qtd}}</span>
                          <v-btn color="success" icon small @click="$emit('clique-botao-add',pIndex)" class="mx-0">
                            <v-icon>add</v-icon>
                          </v-btn>
                        </v-item-group>
                        <span class="subheading font-weight-bold">
                          R$ {{(produto.subtotal*produto.qtd).toFixed(2).replace('.',',')}}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
              </v-card>
            </template>
        </template>
        <template v-if="!registrando">
          <div class="text-xs-center">
            <v-btn color="success" @click="$emit('fechar-modal')">
              Continuar comprando
            </v-btn>
            <v-btn color="success" @click="registrando = true,hrlregistrar=null">Finalizar pedido</v-btn>
          </div>
        </template>
        <template v-else>
          <v-card class="mx-2">
            <v-card-text class="elevation-1">
              <v-flex xs12>
                <v-select label="Forma de Pagamento" :items="formaspagamento" v-model="dadosPost.formaspagamento"></v-select>
              </v-flex>
              <v-flex xs12>
                <v-textarea rows="3" v-model="dadosPost.endereco">
                  <template v-slot:label><div>Endereço Completo</div></template>
                </v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-textarea rows="3" v-model="dadosPost.observacoes">
                  <template v-slot:label><div>Observações</div></template>
                </v-textarea>
              </v-flex>
              <div class="text-xs-center">
                <v-btn v-if="!hrlregistrar" color="success" @click="registrarPedido">Registrar pedido</v-btn>
                <a v-else class="v-btn theme--light success" target="_blank" :href="hrlregistrar">Registrar pedido</a>
              </div>
            </v-card-text>
          </v-card>
        </template>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import jquery from 'jquery';
  
  export default {
    props:['baseUrlApi','dialog','cart','totalPedido','usuario','pages','formaspagamento'],
    data () {
      return {
        //dialog: false,
        loader: null,
        registro_erro: {msg: null,code: null},
        registrandopedido: false,
        notifications: false,
        sound: true,
        hrlregistrar: null,
        widgets: false,
        dadosPost: {
          entrega: null,
          retirada: null,
          endereco: "",
          observacoes: "",
          cupom: null,
          formaspagamento: '',
          opcoesDeEntrega: [],
          opcoesDeRetirada: []
        },
        obs: {entrega: null},
        opcoes: null,
        registrando: null,
        enderecosParaEntrega: [],
        fieldCupom: null,
        errorCupom: null,
        dadosDoCupom: null,
        enderecosEmpty: false
      }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      }
    },
    methods:{
      fecharModal(){
        this.registrando = null;
        this.$emit('fechar-modal');
      },
      finalizarPedido(){
        //console.log("finalizar pedido");
        if(!this.usuario){
          this.$emit('acesso-de-usuario');
        }else{
          //console.log(this.baseUrlApi+'cadastroDeUsuario/getEnderecos');
          jquery.get(this.baseUrlApi+'cadastroDeUsuario/getEnderecos')
            .then(response =>(this.resposta_finalizarPedido(response)));
        }
      },
      resposta_finalizarPedido(response){
        if(!response.situacao && response.erro && response.erro=='loginno'){
          this.$emit('erro-loginno');
          return;
        }
        this.registrando = true;
        this.enderecosParaEntrega = response.dados.enderecos;
        if(response.dados.obs.entrega){
          this.obs.entrega = response.dados.obs.entrega;
        }
        if(response.dados.opcoes){
          this.opcoes = response.dados.opcoes;
        }
        if(response.dados.enderecosEmpty){
          this.enderecosEmpty = response.dados.enderecosEmpty;
        }
        //opcoesementrega
      },
      registrarPedido(){
        if(!this.dadosPost.formaspagamento || this.dadosPost.formaspagamento==""){
          this.$emit('snackbar-alert','Para registrar seu pedido, você precisa escolher a forma de pagamento.','error');
          return;
        }
        if(!this.dadosPost.endereco || this.dadosPost.endereco==""){
          this.$emit('snackbar-alert','Para registrar seu pedido, você precisa informar seu endereço completo.','error');
          return;
        }
        this.$emit('registrar-pedido',this.dadosPost);
      },
      verificarCupom(){
        //testep
        //this.fieldCupom
        if(this.fieldCupom==''){
          return;
        }
        jquery.get(this.baseUrlApi+"public_negocios/verificarCupom/"+this.fieldCupom).then(response => (this.resposta_verificarCupom(response)));
      },
      resposta_verificarCupom(response){
        if(response.situacao == true){
          //console.log(response.dados);
          //console.log(response.dados.cupom.config);
          this.dadosDoCupom = response.dados.cupom;
          this.dadosPost.cupom = response.dados.cupom.id;
          this.$emit("snackbar-alert","Cupom aplicado","success");
        }else{
          //console.log(response);
          this.$emit("snackbar-alert",response.mensagem,"error");
          this.errorCupom = response.mensagem;
        }
      },
      desativarCupom(){
        this.dadosDoCupom = null;
        this.dadosPost.cupom = null;
      }
    },
    computed:{
      totalDoPedidoAposDesconto(){
        var total = this.totalPedido.total;
        if(this.dadosDoCupom && this.dadosDoCupom!=null){
          if(parseInt(this.dadosDoCupom.config.qtdminima)>this.totalPedido.itens){
            return total;
          }
          if(parseFloat(this.dadosDoCupom.config.valorminimo)>this.totalPedido.total){
            return total;
          }
          if(this.dadosDoCupom.config.tipo=="valor"){
            total = total - parseFloat(this.dadosDoCupom.config.desconto);
          }else if(this.dadosDoCupom.config.tipo=="porcentagem"){
            total = total - (total*parseFloat(this.dadosDoCupom.config.desconto)/100);
          }
        }
        return total;
      },
      borderopcoes(){
        if(this.registro_erro.code == 'camposobrigatorios'){
          return 'border-error border-2 my-2 px-1';
        }
        return '';
      }
    }
  }
</script>
<style>
  .border-1{
    border-style: solid;
    border-width: 1px;
  }
  .border-2{
    border-style: solid;
    border-width: 2px;
  }
  .border-error{
    border-color:#ff5252;
  }
  .border-primary{
    border-color:#1876D2;
  }
  .calendar{
    width: 100%;
    border: 2px solid #ccc;
  }
  .calendar tr td,.calendar tr th{
    width: 14.2857142%;
  }
  .calendar tr td button{
    max-width: 100%!important;
    min-width: 10px!important;
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>